export default {
  abandonProduct: 'Abandonar producto',
  abandonProductTips:
    'Recordatorio amable: Cuando confirme [Abandonar producto], destruiremos su producto y no podrá recuperarse. El producto no se devolverá al vendedor para un reembolso. Proceda con precaución.',
  finePhotos: 'Fotografía detallada',
  ordinaryPhotos: 'Foto ordinaria',
  expireText: 'El paquete está a punto de caducar',
  more: 'Más',
  timeExpand: 'Período extendido',
  guaranteeService: 'Servicio de garantía',
  noNeed: 'No es necesario',
  'i18n-0000002':
    'Tu artículo ha excedido el período de almacenamiento. Lo conservaremos por 28 días adicionales. Después de este período, se considerará abandonado y será desechado en consecuencia.',
  'i18n-0000003':
    'Si necesita extender el período de almacenamiento, por favor adquiera el servicio de valor agregado para almacenamiento extendido dentro de los próximos 28 días.',
  'i18n-0000004': 'Tiempo de expiración del almacenamiento',
  'i18n-0000016': 'El almacenamiento del producto ha expirado',
  'i18n-0000019':
    'Extensión de almacenamiento no pagada. El artículo se considera abandonado voluntariamente.',
  'i18n-0000023': 'Completado',
  refundTip: 'Tras la confirmación, se reembolsará el importe del almacenamiento a tu cuenta.',
  storageEnum: {
    1: 'Almacén 1, China',
    2: 'Almacén 2, China',
  },
  'i18n-00001':
    'Acepto los cambios en la información de mi declaración proporcionados por acbuy para cumplir con los requisitos aduaneros locales y mejorar las tarifas de despacho de aduanas. Si no contrato un seguro, seré el único responsable de las responsabilidades y consecuencias derivadas del despacho de aduanas.',
  'i18n-00002':
    'No acepto los cambios. Por favor, declare tal como están. Seré el único responsable de las responsabilidades y consecuencias derivadas del despacho de aduanas.',
  'i18n-00003': 'Acepto los cambios',
  'i18n-00004': 'No acepto los cambios',
  'i18n-00005': 'Cambio de información de la declaración',
  'i18n-00006':
    'Cada declaración debe tener más de 25 caracteres. Por favor, ajústela y vuelva a enviarla.',
  'i18n-00007':
    'Basado en el peso real o volumétrico, el que sea mayor. Cualquier diferencia será reembolsada o cobrada dentro de las 72 horas posteriores al embalaje.',
  'i18n-00008':
    'Cada mensaje de declaración debe contener menos de {length} caracteres. Por favor, ajuste y vuelva a enviar',
  'i18n-00009':
    '{AI} aún tiene servicios de valor añadido pendientes de pago. Para conservarlos, complete el pago y espere a que el servicio finalice antes de enviar el paquete. Si elige enviar el paquete ahora, el sistema cancelará automáticamente los servicios de valor añadido correspondientes que no se hayan pagado.',
}
